(ns common.patterns.stats-daterange-select
  (:require ["@mui/material/MenuItem$default" :as MenuItem]
            ["@mui/material/Select$default" :as Select]
            ["@mui/material/Typography$default" :as Typography]
            [common.localstorage :as localstorage]
            [common.util :as util]
            [uix.core :refer [$ defui]]))

(def daterange-key "stats-daterange")

(def recent-stats-window 28)

(def recent-stats-daterange
  {:start-date (.toISOString (util/n-days-ago recent-stats-window))
   :end-date (.toISOString (util/today))})

(def options
  [{:id :today
    :label "Today"
    :value {:start-date (.toISOString (util/today))
            :end-date (.toISOString (util/tomorrow))}}
   {:id :yesterday
    :label "Yesterday"
    :value {:start-date (.toISOString (util/yesterday))
            :end-date (.toISOString (util/today))}}
   {:id :this-month
    :label "This month"
    :value {:start-date (.toISOString (util/start-of-this-month))
            :end-date (.toISOString (util/start-of-next-month))}}
   {:id :last-month
    :label "Last month"
    :value {:start-date (.toISOString (util/start-of-last-month))
            :end-date (.toISOString (util/start-of-this-month))}}
   {:id :lifetime
    :label "Lifetime"
    :value {:start-date (.toISOString (new js/Date (.UTC js/Date 2000 0 1)))
            :end-date (.toISOString (util/tomorrow))}}])

(defn daterange->id [range]
  (->> options
       (filterv #(= (:value %) range))
       first
       :id))

(defn id->daterange [id]
  (->> options
       (filterv #(= (:id %) id))
       first
       :value))

(defn get-initial-daterange []
  (or (id->daterange (keyword (localstorage/get daterange-key))) (:value (first options))))

(defui daterange-select [{:keys [value on-change]}]
  (let [value* (or value (:value (first (filter #(= (:id %) :lifetime) options))))]
    ($ Select {:variant "filled"
               :displayEmpty true
               :value value*
               :onChange (fn [e]
                           (let [value (.. e -target -value)]
                             (localstorage/save! daterange-key (daterange->id value))
                             (on-change value)))
               :renderValue (fn [v]
                              (let [label (:label (first (filter #(= v (:value %)) options)))]
                                ($ :<>
                                   ($ Typography {:component "span"
                                                  :fontWeight 500} "Date range: ")
                                   (when label
                                     ($ Typography {:component "span"} label)))))
               :size "small"}
       (for [{:keys [id label value]} options]
         ($ MenuItem {:key id :value value} label)))))
